import theme from '../../../theme';

const Hamburger = ({ width, height, color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '25'}
    height={height || '25'}
    viewBox="0 0 33 32"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.42499 6.07719C5.42499 6.60738 5.85479 7.03719 6.38499 7.03719H26.865C27.3952 7.03719 27.825 6.60738 27.825 6.07719C27.825 5.54699 27.3952 5.11719 26.865 5.11719H6.38499C5.85479 5.11719 5.42499 5.54699 5.42499 6.07719ZM5.42499 15.0346C5.42499 15.5648 5.85479 15.9946 6.38499 15.9946H26.865C27.3952 15.9946 27.825 15.5648 27.825 15.0346C27.825 14.5044 27.3952 14.0746 26.865 14.0746H6.38499C5.85479 14.0746 5.42499 14.5044 5.42499 15.0346Z"
      fill={color || theme.colors.neutralSurface}
    />
    <path
      d="M6.38523 24.96C5.85504 24.96 5.42523 24.5302 5.42523 24C5.42523 23.4698 5.85504 23.04 6.38523 23.04H26.8652C27.3954 23.04 27.8252 23.4698 27.8252 24C27.8252 24.5302 27.3954 24.96 26.8652 24.96H6.38523Z"
      fill={color || theme.colors.neutralSurface}
    />
  </svg>
);

export default Hamburger;
